// eslint-disable-next-line
export const createField = (id, value, isCustomField) => {
  let field = value
  return field
}

export default { createField }
